export const bonusCategories = [
  ['poles', 'Most pole positions', 1],
  ['zeroPoints', 'Drivers with zero points', 1],
  ['champion', 'Drivers’ champion', 2],
  ['constructor', 'Constructors’ champion', 2],
  ['sprint', 'Most sprint points', 1],
  ['penalties', 'Most penalty seconds', 1],
];

export function positionPoints(predicted, actual) {
  return Number.isInteger(actual) && actual > 0 ? [8, 5, 3, 1][Math.abs(predicted - actual)] ?? 0 : 0;
}

export function standingOrder(standings, count) {
  const order = Array(Math.max(count, ...standings.map(row => row.position))).fill('');
  standings.forEach(row => { order[row.position - 1] = row.id; });
  return order;
}

export function initialScenario(data) {
  const bonus = Object.fromEntries(bonusCategories.map(([key]) => [key,
    [...(data.bonusResults.find(result => result.key === key)?.actual || [])],
  ]));
  const drivers = standingOrder(data.driverStandings, data.drivers.length);
  const teams = standingOrder(data.teamStandings, data.teams.length);
  return {
    drivers, teams,
    bonus: {
      ...bonus,
      champion: drivers[0] ? [drivers[0]] : [],
      constructor: teams[0] ? [teams[0]] : [],
      zeroPoints: data.driverStandings.length ? String(data.driverStandings.filter(row => row.points === 0).length) : '',
    },
  };
}

// Choosing an already ranked entry swaps the two positions, keeping the order unique.
export function changePosition(order, index, id) {
  const next = [...order];
  const previousIndex = id ? next.indexOf(id) : -1;
  if (previousIndex !== -1) next[previousIndex] = next[index];
  next[index] = id;
  return next;
}

export function scoreSimulation(picks, scenario) {
  const details = (predictions, order) => predictions.map((id, index) => ({
    id, position: index + 1, actualPosition: order.includes(id) ? order.indexOf(id) + 1 : null,
    points: positionPoints(index + 1, order.includes(id) ? order.indexOf(id) + 1 : null),
  }));
  const driverDetails = details(picks.drivers, scenario.drivers);
  const teamDetails = details(picks.teams, scenario.teams);
  const bonusDetails = bonusCategories.map(([key, label, availablePoints]) => {
    const value = scenario.bonus[key];
    const actual = key === 'zeroPoints' ? (value === '' ? [] : [String(value)]) : value;
    return { key, label, availablePoints, points: !actual.length ? null : actual.includes(String(picks.bonus[key])) ? availablePoints : 0 };
  });
  const sum = rows => rows.reduce((total, row) => total + (row.points ?? 0), 0);
  const drivers = sum(driverDetails), teams = sum(teamDetails), bonus = sum(bonusDetails);
  return { drivers, teams, bonus, total: drivers + teams + bonus, driverDetails, teamDetails, bonusDetails };
}

export function simulateLeague(players, scenario) {
  const rows = players.map(player => ({ ...player, score: scoreSimulation(player.picks, scenario) }))
    .sort((a, b) => b.score.total - a.score.total || a.username.localeCompare(b.username));
  let rank = 0;
  return rows.map((row, index) => {
    if (index === 0 || row.score.total !== rows[index - 1].score.total) rank = index + 1;
    return { ...row, rank };
  });
}
